const translations = require('../translations');

export function translateValue(category, value, lang) {
  try {
    return translations[lang][category][value] || value;
  } catch (TypeError) {
    return value;
  }
}

export function translateDataValue(value, lang='en') {
  try {
    const whitespaceIndex = value.indexOf(' ');
    if (whitespaceIndex > 0) {
      const val = value.substr(0, whitespaceIndex);
      const unit = value.substr(whitespaceIndex + 1);
      const translatedUnit = translateValue('units', unit, lang) || unit;
      return `${val} ${translatedUnit}`;
    } else {
      return value;
    }
  } catch (TypeError) {
    return value;
  }
}

export function translatePassage(category, key, params={}, lang='en') {
  try {
    let sentence = translations[lang][category][key] || '';
    Object.keys(params).forEach((key) => {
      sentence = sentence.replace(`%${key}%`, params[key]);
    });
    return sentence;
  } catch (TypeError) {
    return '';
  }
}
